import { ReactNode } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import AppLoader from "@/components/AppLoader";
import LegalConsentGate from "@/components/legal/LegalConsentGate";

export default function RequireAuth({ children }: { children: ReactNode }) {
  // Login bypass enabled — auth gate disabled.
  return (
    <>
      <LegalConsentGate />
      {children}
    </>
  );
}
